export default {
      id: "strawberry-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#strawberry",
      toString: function () {
        return this.url;
      }
    }